import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {
    ICommunitySEONewPagesIncoming
} from "../../../models/community/seo/newPageTracking/ICommunitySEONewPagesIncoming";
import {
    ICommunitySEONewPagesSearchOutgoing
} from "../../../models/community/seo/newPageTracking/ICommunitySEONewPagesSearchOutgoing";
import {
    ICommunitySEOPageReportIncoming
} from "../../../models/community/seo/newPageTracking/report/ICommunitySEOPageReportIncoming";
import {ICommunitySEONewPageIncoming} from "../../../models/community/seo/newPageTracking/ICommunitySEONewPageIncoming";
import {WebSocketCommunityEventName} from "../../../network/socket/names/WebSocketCommunityEventName";
import {arrayRemove} from "../../../sedestral/framework/utilities/ArrayRemove";

export class CommunitySeoNewPageTrackingService {

    public static events: ((page: ICommunitySEONewPageIncoming) => void)[] = [];
    public static deleteEvents: ((url: string) => void)[] = [];

    public static dispose(): void {
        this.events = [];
        this.deleteEvents = [];
    }

    public static init(): void {
        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_SEO_PAGE_TRACKING_UPDATE, (page: ICommunitySEONewPageIncoming) => {
            this.events.forEach(value => value(page));
        });
        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_SEO_PAGE_TRACKING_DELETE, (url: string) => {
            this.deleteEvents.forEach(value => value(url));
        });
    }

    public static onPageTrackingUpdate(component: INetworkComponent, func: (page: ICommunitySEONewPageIncoming) => void) {
        this.events.push(func);
        component.onRemove(() => arrayRemove(this.events, func));
    }

    public static onPageTrackingDelete(component: INetworkComponent, func: (url: string) => void) {
        this.deleteEvents.push(func);
        component.onRemove(() => arrayRemove(this.deleteEvents, func));
    }

    public static async getPages(search: ICommunitySEONewPagesSearchOutgoing, component?: INetworkComponent): Promise<ICommunitySEONewPagesIncoming> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/seo/newPageTracking`, search, component);
        if (request && request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getPage(communityId: string, url: string, component?: INetworkComponent): Promise<ICommunitySEOPageReportIncoming> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/seo/newPageTracking/page?communityId=${encodeURIComponent(communityId)}&url=${encodeURIComponent(url)}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

     public static async setMarkedResolved(communityId: string, url: string, resolved: boolean, component?: INetworkComponent): Promise<boolean> {
        let request = await Network.put(ProductType.COMMUNITY, `/community/seo/pageTracking/markedResolved/${communityId}?url=${encodeURIComponent(url)}&resolved=${resolved}`, {}, component);
        return request.status == HttpStatus.OK;
    }

    public static async retryAnalysisBatch(communityId: string, urls: string[], component?: INetworkComponent): Promise<boolean> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/seo/pageTracking/retryBatch/${communityId}`, urls, component);
        return request.status == HttpStatus.OK;
    }
}
